import React from "react";

const invoices = [
  {
    recipient: "Karur Fabrics",
    invoiceNumber: "INV-54654",
    date: "Aug 22, 2025",
    dueDate: "Aug 29, 2025",
    dueDateNote: "20 days overdue",
    outstanding: "$5000",
    lastAction: "Email sent on Aug 22, 2025",
    nextAction: "Send email on Sept 22, 2025",
    overdue: true,
  },
  {
    recipient: "Sharon Impex",
    invoiceNumber: "INV-54654",
    date: "Sept 22, 2025",
    dueDate: "Sept 28, 2025",
    dueDateNote: "20 days overdue",
    outstanding: "$5000",
    lastAction: "Email sent on Aug 22, 2025",
    nextAction: "Send email on Sept 22, 2025",
    overdue: true,
  },
  {
    recipient: "Sri Priya Auto Exports",
    invoiceNumber: "INV-54654",
    date: "Sept 22, 2025",
    dueDate: "Sept 28, 2025",
    dueDateNote: "20 days overdue",
    outstanding: "$5000",
    lastAction: "Email sent on Aug 22, 2025",
    nextAction: "Send email on Sept 22, 2025",
    overdue: true,
  },
  {
    recipient: "Red Chamber",
    invoiceNumber: "INV-54654",
    date: "Sept 22, 2025",
    dueDate: "Sept 28, 2025",
    dueDateNote: "20 days overdue",
    outstanding: "$5000",
    lastAction: "Email sent on Aug 22, 2025",
    nextAction: "Send email on Sept 22, 2025",
    overdue: true,
  },
  {
    recipient: "Chennai Metco",
    invoiceNumber: "INV-54654",
    date: "Sept 22, 2025",
    dueDate: "Sept 28, 2025",
    dueDateNote: "20 days overdue",
    outstanding: "$5000",
    lastAction: "Email sent on Aug 22, 2025",
    nextAction: "Send email on Sept 22, 2025",
    overdue: true,
  },
];
const AdminInvoices = () => (
  <section className="card my-8">
    <div className="p-6">
      <button className="mb-4 px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-600 hover:text-white transition">
        Create Invoice
      </button>
      <table className="min-w-full border-collapse">
        <thead>
          <tr className="bg-gray-600 text-sm text-white text-left">
            <th className="px-4 py-2 rounded-tl">Invoice Recipient</th>
            <th className="px-4 py-2">Invoice Number</th>
            <th className="px-4 py-2 w-10">Date</th>
            <th className="px-4 py-2">Due Date</th>
            <th className="px-4 py-2">Outstanding</th>
            <th className="px-4 py-2">Last Action</th>
            <th className="px-4 py-2 rounded-tr">Next Action</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice, index) => (
            <tr
              key={index}
              className={`text-sm border-b border-gray-200 ${
                index % 2 === 0 ? "bg-white" : "bg-gray-50"
              }`}
            >
              <td className="px-4 py-3 font-semibold">{invoice.recipient}</td>
              <td className="px-4 py-3 text-gray-600">
                {invoice.invoiceNumber}
              </td>
              <td className="px-4 py-3 text-gray-600">{invoice.date}</td>
              <td className="px-4 py-3">
                <span
                  className={`block ${
                    invoice.overdue ? "text-gray-600 font-semibold" : ""
                  }`}
                >
                  {invoice.dueDate}
                </span>
                <small
                  className={`block text-xs ${
                    invoice.overdue ? "text-gray-400" : "text-gray-400"
                  }`}
                >
                  {invoice.dueDateNote}
                </small>
              </td>
              <td className="px-4 py-3 font-mono">{invoice.outstanding}</td>
              <td className="px-4 py-3 text-gray-600">{invoice.lastAction}</td>
              <td className="px-4 py-3 text-gray-600">{invoice.nextAction}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* pagination and buttons can be added below */}
    </div>
  </section>
);

export default AdminInvoices;
